import React from 'react';
import { useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';
import PageHeader from "../components/gamePlayComponents/PageHeader";

const PageNotFound = () => {
    const navigate = useNavigate();
    return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
            <PageHeader goBack title={"Page not found"} />
            <p>The page you're looking for doesn't exist.</p>
            <Button variant="contained" color="primary" onClick={() => navigate('/')}>
                Go to Home
            </Button>
        </div>
    );
};

export default PageNotFound;
